import { render, staticRenderFns } from "./IOContainer.vue?vue&type=template&id=2f9ceb06"
import script from "./IOContainer.vue?vue&type=script&lang=js"
export * from "./IOContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports